import * as angular from "angular";
import { UnlinkedExternalAccountsRepo, UnlinkedExternalAccount } from "@services/portfolios/unlinked-external-accounts.repo";
import { ClientRepo } from "@services/clients/client.repo";

interface Client {
    id: number;
    clientNumber: string;
    name: string;
    displayText: string;
}

export class LinkAccountModalController implements angular.IOnInit {
    public account: UnlinkedExternalAccount;
    public clients: Client[] = [];
    public selectedClient: Client;
    public searchTextClient: string = '';
    public loading: boolean = false;

    static $inject = [
        'unlinkedExternalAccountsRepo',
        'clientRepo',
        'notifyjs',
        '$mdDialog'
    ];

    constructor(
        private unlinkedExternalAccountsRepo: UnlinkedExternalAccountsRepo,
        private clientRepo: ClientRepo,
        private notifyjs: any,
        private $mdDialog: angular.material.IDialogService
    ) {}

    $onInit(): void {
        this.loadClients();
    }

    loadClients(): void {
        this.loading = true;
        this.clientRepo.getClientsForSelection().then((response: any) => {
            this.clients = response.data.map((client: any) => ({
                id: client.id,
                clientNumber: client.clientNumber || '',
                name: client.displayName || '',
                displayText: client.clientNumber ? `${client.clientNumber} - ${client.displayName || ''}` : (client.displayName || '')
            }));
        }).catch((error) => {
            this.notifyjs('Failed to load clients', 'error');
            console.error('Error loading clients:', error);
        }).finally(() => {
            this.loading = false;
        });
    }

    filterClients(searchText: string): Client[] {
        if (!searchText || searchText.trim() === '') {
            return this.clients.slice(0, 50); // Limit to first 50 for performance
        }
        
        const query = searchText.toLowerCase().trim();
        return this.clients.filter(client => 
            (client.displayText && client.displayText.toLowerCase().includes(query)) ||
            (client.clientNumber && client.clientNumber.toLowerCase().includes(query)) ||
            (client.name && client.name.toLowerCase().includes(query))
        );
    }

    updateSelectedClient(client: Client): void {
        console.log('updateSelectedClient called with:', client);
        if (client) {
            this.selectedClient = client;
            this.searchTextClient = client.displayText;
            console.log('Selected client:', this.selectedClient);
        }
    }

    linkAccount(): void {
        if (!this.selectedClient) {
            this.notifyjs('Please select a client', 'error');
            return;
        }

        this.loading = true;
        this.unlinkedExternalAccountsRepo.linkAccountToClient(this.account.id, this.selectedClient.id)
            .then((response) => {
                this.$mdDialog.hide({ success: true });
            })
            .catch((error) => {
                this.notifyjs('Failed to link account to client', 'error');
                console.error('Error linking account:', error);
            })
            .finally(() => {
                this.loading = false;
            });
    }

    cancel(): void {
        this.$mdDialog.cancel();
    }
}

export const LinkAccountModalComponent: angular.IComponentOptions = {
    template: require('./link-account-modal.html'),
    controller: LinkAccountModalController,
    controllerAs: '$ctrl',
    bindings: {
        account: '<'
    }
};





// WEBPACK FOOTER //
// ./src/app/clientmanagement/unlinked-external-accounts/link-account-modal.controller.ts